import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userService from "../../../store/services/user.service";
import "react-datepicker/dist/react-datepicker.css";
import { generalActions } from "../../../store/actions";
import { useColumnConfig } from "./ColumnConfigProvider";
import { getColumnWidth } from "../../../helpers/cookieUtils";
import { ReminderModal as CreateReminder } from "../modal/reminder/Reminder";
import Modal from "../modal/Modal";
import ClientTable from "./ClientTable";
import PortfolioTable from "./PortfolioTable";
import ProgramTable from "./ProgramTable";
import ProjectTable from "./ProjectTable";
import ScopeTable from "./ScopeTable";
import MilestoneTable from "./MilestoneTable";
import TaskTable from "./TaskTable";
import RoleTable from "./RoleTable";
import ResourceTable from "./ResourceTable";
import ShiftTable from "./ShiftTable";
import AllocatedResourceTable from "./AllocatedResourceTable";
import ChangeRequestTable from "./ChangeRequestTable";
import RiskTable from "./RiskTable";
import CommunicationPlanTable from "./CommunicationPlanTable";
import MeetingMinutesTable from "./MeetingMinutesTable";
import BudgetTable from "./ BudgetTable";
import HealthStatusTable from "./HeathStatusTable";
import DecisionLogTable from "./DecisionLogTable";
import RunbookTable from "./RunbookTable";
import ReshuffleRequestTable from "./ReshuffleRequestTable";
import {
  permissionLoader,
  shouldPermissionModalOpen,
} from "../../../store/selectors/user.selector";
import {
  getPermissionsRequest,
  updatePermissionStatus,
} from "../../../store/actions/user.actions";
import RolesSetup from "../roles/Roles";
import PurchaseOrdersTable from "./PurchaseOrdersTable";
import InvoiceRegistryTable from "./InvoiceRegistryTable";
import BudgetCategoryTable from "./BudgetCategoryTable";
import { TABLE_ACTIONS } from "./utils/tableUtils";

const Table = ({
  type,
  rows,
  searchHandler,
  body,
  saveBtnLabel,
  cancelBtnLabel,
  setPageNum,
  setIsCreate = () => { },
  handleSave,
  handleDelete,
  handleCancel,
  handleRefresh,
  setIsEdit,
  loading,
  modalLoading = false,
  isCreate,
  forceShowDeleteModal,
  pagination,
  setSelectedRow,
  parentType = null,
  overviewType,
  dashboardFilterSetId,
  dashboardFilterSetName,
  scopeId,
  handleAddRow,
  handleCancelAddRow,
  perPageItems,
  setData,
  handleListingView,
  handleKanbanView,
  kanbanView,
  isHeader,
  handlePermissions,
  handleSavePermissions,
  permissions,
  isCalendarView,
  setIsCalendarView,
  filterRegistry,
  forceShowEditModal = null,
  isNoFixedHeight = false,
  projectId,
  triggerSearch,
  isModalSaveBtnDisabled = false,
  handleAction = null,
  modalWidth = null,
  onAddTaskToGroup,
  onTaskGroupChanged,
  taskGroupId
}) => {
  const [columns, setColumns] = useState([]);
  const [rowData, setRowData] = useState(rows || []);
  const tableRef = useRef(null);
  const { tableName, tableColumns, columnConfig, updateColumnConfig } =
    useColumnConfig();
  const dispatch = useDispatch();
  const [modalTitle, setmodalTitle] = useState(`Create ${type}`);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const isPermissionModalOpen = useSelector(shouldPermissionModalOpen);
  const getPermissionLoading = useSelector(permissionLoader);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [permissionTitle, setPermissionTitle] = useState("");
  const [isDefaultRole, setIsDefaultRole] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isStatusUpdate, setIsStatusUpdate] = useState(false);
  const [confirmationTitle, setConfirmationTitle] = useState("");
  const [confirmationDesc, setConfirmationDesc] = useState("");
  const [confirmationBtn, setConfirmationBtn] = useState("");
  const [TableActionModalData, setTableActionModalData] = useState({
    isShow: false,
    title: "",
    body: "",
    handleCancel: () => { },
    handleConfirm: () => { },
    saveBtnLabel: "Confirm",
    cancelBtnLabel: "Cancel",
  });
  const isOverviewHeaderCollapsed = localStorage.getItem("isOverviewHeaderCollapsed") === "true";

  useEffect(() => {
    if (type === "Resource") {
      selectedItem?.isActive
        ? setConfirmationTitle("Deactivate user")
        : setConfirmationTitle("Activate user");
      selectedItem?.isActive
        ? setConfirmationDesc(
          "Are you sure you want to deactivate the selected user? "
        )
        : setConfirmationDesc(
          "Are you sure you want to activate the selected user? "
        );
      selectedItem?.isActive
        ? setConfirmationBtn("Deactivate")
        : setConfirmationBtn("Activate");
    }
  }, [selectedItem, type]);

  const getReminderType = (type) => {
    switch (type) {
      case "Role":
        return "Role";
      case "Shift":
        return "Shift";
      case "Client":
        return "Client";
      case "Portfolio":
        return "Portfolio";
      case "Program":
        return "Program";
      case "Project":
        return "Project";
      case "Scope":
        return "Scope";
      case "Milestone":
        return "Milestone";
      case "Resource":
      case "Allocated Resources":
        return "User";
      case "Tasks":
        return "Task";
      case "Risk":
        return "Risk";
      case "Change Request":
        return "ChangeRequest";
      case "Budget":
      case "BudgetCategory":
        return "Budget";
      case "Communication Plan":
        return "CommunicationPlan";
      default:
        return "";
    }
  };

  const getModalWidth = () => {
    if(modalWidth)
      return modalWidth;

    switch (type) {
      case "Tasks":
        return "800px";
      case "Reshuffle Request":
        return "1000px";
      default:
        return null;
    }
  };

  useEffect(() => {
    if (!modalLoading) {
      setShowModal(false);
      setShowDeleteModal(false);
      if (type === "Role" && isCreate) {
        const item = JSON.parse(localStorage.getItem("selectedRow"));
        handleShowPermissions(item);
      }
      setIsCreate(false);
      setShowConfirmationModal(false);
    }
  }, [modalLoading]);

  useEffect(() => {
    if (isCreate) {
      setShowModal(true);
      let title = `Create  ${type}`;

      if(type === "Resource")
        title = `Add ${type}`;

      else if(type === "Reshuffle Request")
        title = `Add Request`;
      setmodalTitle(title);
      setSelectedRow({});
    } else {
      setShowModal(false);
    }
  }, [isCreate]);

  useEffect(() => {
    if (forceShowEditModal) {
      setShowModal(true);
      setmodalTitle(`Edit ${type === "BudgetCategory" ? "Budget" : type}`);
      setIsEdit(true);
      setSelectedItem(forceShowEditModal);
      setSelectedRow(forceShowEditModal);
    } else {
      setShowModal(false);
    }
  }, [forceShowEditModal]);

  useEffect(() => {
    if (forceShowDeleteModal != null) {
      setShowDeleteModal(forceShowDeleteModal);
    }
  }, [forceShowDeleteModal]);

  const handeCancel = () => {
    handleCancel();
    setShowModal(false);
    setIsCreate(false);
    setShowConfirmationModal(false);
    setShowDeleteModal(false);
    setIsStatusUpdate(false);
    localStorage.removeItem("selectedRow");
  };

  const handleShowPermissions = (item) => {
    setShowPermissionModal(true);
    setPermissionTitle(item?.name || "");
    setIsDefaultRole(item?.isDefault || false);
    dispatch(getPermissionsRequest(item.id));
    localStorage.setItem("selectedRow", JSON.stringify(item));
  };

  const handleEditAction = (item) => {
    setShowModal(true);
    let title = `Edit ${type === "BudgetCategory" ? "Budget" : type}`

    if(type === "Milestone" && item?.isLinked)
      title = `View ${type}`;

    else if(type === "Reshuffle Request")
        title = `Edit Request`;

    setmodalTitle(title);
    setIsEdit(true);
    setSelectedItem(item);
    setSelectedRow(item);
  };

  const handleDeleteAction = (item) => {
    setShowDeleteModal(true);
    setSelectedItem(item);
    setSelectedRow(item);
  };

  const handleReminderAction = (item) => {
    setShowReminderModal(true);
    setSelectedItem(item);
    setSelectedRow(item);
  };

  const handleConfirm = () => {
    setIsStatusUpdate(true);
  };

  const handleStatus = () => {
    setShowConfirmationModal(true);
  };

  // Handle Reorder Columns
  const handleReorderColumns = (results) => {
    if (results?.length) {
      const updatedColumnsDB = results.map((col) => ({
        name: col.label,
        customName: col.customName ?? "",
        order: col.order,
        isVisible: col.isVisible,
      }));

      const payload = {
        Name: tableName,
        Columns: updatedColumnsDB,
      };
      userService
        .putUserLayoutRequest(payload)
        .then(() => { })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Error updating column ordering",
              type: "error",
            })
          );
        })
        .finally(() => {
          updateColumnConfig(results);
        });
    }
  };

  const sortedColumnConfig = useMemo(
    () =>
      columnConfig.length
        ? [...columnConfig].sort((a, b) => a.order - b.order)
        : [],
    [columnConfig]
  );

  const path = window.location.pathname;
  const parentIdFromPath = path.split("/")[3];

  let clientIdFromPath = null;
  let portfolioIdFromPath = null;
  let programIdFromPath = null;
  let projectIdFromPath = null;

  switch (parentType) {
    case "Client":
      clientIdFromPath = parentIdFromPath;
      break;
    case "Portfolio":
      portfolioIdFromPath = parentIdFromPath;
      break;
    case "Program":
      programIdFromPath = parentIdFromPath;
      break;
    case "Project":
      projectIdFromPath = parentIdFromPath;
      break;
  }
  useEffect(() => {
    if (sortedColumnConfig?.length) {
      const newColumns = sortedColumnConfig.map((col) => ({
        accessorKey: col.accessorKey,
        header: col.customName !== "" ? col.customName : col.label,
        size: getColumnWidth(tableName, col.accessorKey),
        isVisible: col.isVisible,
        isSortable: col.isSortable,
        columnType: col.columnType,
        required: true,
        columnId: col.columnId,
        order: col.order,
        label: col.label,
        customName: col.customName ?? "",
      }));
      setColumns((prevColumns) => {
        if (JSON.stringify(prevColumns) !== JSON.stringify(newColumns)) {
          return newColumns;
        }
        return prevColumns;
      });
      setRowData(rows);
    } else if (tableColumns?.length > 0) {
      const newColumns = tableColumns.map((col) => ({
        accessorKey: col.accessorKey,
        header: col.label,
        size: getColumnWidth(tableName, col.accessorKey),
        isVisible: col.isVisible,
        isSortable: col.isSortable,
        columnType: col.columnType,
        required: true,
        columnId: col.columnId,
        order: col.order,
        label: col.label,
        customName: "",
      }));
      setColumns(newColumns);
    }
  }, [sortedColumnConfig, rows, tableName, loading]);


  const resetTableActionModalData = () => {
    setTableActionModalData({
      isShow: false,
      title: "",
      body: "",
      handleCancel: () => { },
      handleConfirm: () => { },
      saveBtnLabel: "Confirm",
      cancelBtnLabel: "Cancel",
    });
  };

  const handleTableAction = (params) => {
    switch  (params.actionType) {
      case TABLE_ACTIONS.DUPLICATE:
        setTableActionModalData({
          isShow: true,
          title: "Duplication Confirmation",
          body: `Are you sure you want to duplicate ${params.payload.name || "this item"}?`,
          handleCancel: resetTableActionModalData,
          handleConfirm: () => {
            handleAction(params);
            setTableActionModalData((prev) => ({ ...prev, isShow: false }));
          },
          saveBtnLabel: "Confirm",
          cancelBtnLabel: "Cancel",
        });
        break; 
        
        default:
          return;
      }
  };

  const renderTables = useCallback(
    (type) => {
      switch (type) {
        case "Role":
          return (
            <RoleTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              setRowData={setData}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              roleLoading={loading}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              handlePermissions={handleShowPermissions}
              triggerSearch={triggerSearch}
            />
          );
        case "Resource":
          return (
            <ResourceTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              resourceLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              handleStatus={handleStatus}
              updateStatus={isStatusUpdate}
              setUpdateStatus={setIsStatusUpdate}
              handleRefresh={handleRefresh}
              triggerSearch={triggerSearch}
            />
          );
        case "Shift":
          return (
            <ShiftTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              setRowData={setData}
              shiftLoading={loading}
              parentType={parentType}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Allocated Resources":
          return (
            <AllocatedResourceTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              clientId={clientIdFromPath}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              resourceLoading={loading}
              parentType={parentType}
              setRowData={setData}
              triggerSearch={triggerSearch}
            />
          );
        case "Client":
          return (
            <ClientTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              setRowData={setData}
              clientLoading={loading}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              triggerSearch={triggerSearch}
            />
          );
        case "Portfolio":
          return (
            <PortfolioTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              overviewType={overviewType}
              clientId={clientIdFromPath}
              dashboardFilterSetId={dashboardFilterSetId}
              dashboardFilterSetName={dashboardFilterSetName}
              portfolioLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Program":
          return (
            <ProgramTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              clientId={clientIdFromPath}
              portfolioId={portfolioIdFromPath}
              programLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Project":
          return (
            <ProjectTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              setSelectedRow={setSelectedRow}
              clientId={clientIdFromPath}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              projectLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Scope":
          return (
            <ScopeTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              scopeLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
              handleAction = {handleTableAction}
            />
          );
        case "Milestone":
          return (
            <MilestoneTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              milesonesLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Tasks":
          return (
            <TaskTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              scopeId={scopeId}
              taskLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              handleListingView={handleListingView}
              handleKanbanView={handleKanbanView}
              kanbanView={kanbanView}
              triggerSearch={triggerSearch}
              handleAction = {handleTableAction}
              onAddTaskToGroup={onAddTaskToGroup}
              onTaskGroupChanged={onTaskGroupChanged}
              taskGroupId={taskGroupId}
            />
          );
        case "Change Request":
          return (
            <ChangeRequestTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              chRequestLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Risk":
          return (
            <RiskTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              overviewType={overviewType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              dashboardFilterSetId={dashboardFilterSetId}
              dashboardFilterSetName={dashboardFilterSetName}
              riskLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Communication Plan":
          return (
            <CommunicationPlanTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              clientId={clientIdFromPath}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              cmPlanLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              isCalendarView={isCalendarView}
              setIsCalendarView={setIsCalendarView}
              triggerSearch={triggerSearch}
            />
          );
        case "BudgetCategory":
          return (
            <BudgetCategoryTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectId ?? projectIdFromPath}
              budgetLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
            />
          );
        case "Budget":
          return (
            <BudgetTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              budgetLoading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
            />
          );
        case "MeetingRegistry":
          return (
            <MeetingMinutesTable
              columnsList={columns}
              rowData={rowData}
              searchHandler={searchHandler}
              filterRegistry={filterRegistry}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              meetingsLoading={loading}
              setRowData={setData}
              triggerSearch={triggerSearch}
            />
          );
        case "HealthStatus":
          return (
            <HealthStatusTable
              columnsList={columns}
              rowData={rowData}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              loading={loading}
            />
          );
        case "Purchase Order":
          return (
            <PurchaseOrdersTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              projectId={projectIdFromPath}
              loading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Invoice":
          return (
            <InvoiceRegistryTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              projectId={projectIdFromPath}
              loading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Decision":
          return (
            <DecisionLogTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              portfolioId={portfolioIdFromPath}
              programId={programIdFromPath}
              projectId={projectIdFromPath}
              loading={loading}
              setRowData={setData}
              handleAddRow={handleAddRow}
              handleCancelAddRow={handleCancelAddRow}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Runbook":
          return (
            <RunbookTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              projectId={projectIdFromPath}
              loading={loading}
              setRowData={setData}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
            />
          );
        case "Reshuffle Request":
          return (
            <ReshuffleRequestTable
              columnsList={columns}
              rowData={rowData}
              setIsCreate={setIsCreate}
              searchHandler={searchHandler}
              tableName={tableName}
              handleColumnOrdering={handleReorderColumns}
              dispatch={dispatch}
              setPageNum={setPageNum}
              perPageItems={perPageItems}
              pagination={pagination}
              handleReminder={handleReminderAction}
              handleEdit={handleEditAction}
              handleDelete={handleDeleteAction}
              parentType={parentType}
              projectId={projectIdFromPath}
              loading={loading}
              isHeader={isHeader}
              triggerSearch={triggerSearch}
              handleAction={handleAction}
              setRowData={setData}
            />
          );
        default:
          return null;
      }
    },
    [type, columns, rowData, loading]
  );

  return (
    <div
      className={`customTableContainerNew  ${parentType ? "ChildTable" : "ParentTable"
        }`}
      style={{
        height: isNoFixedHeight ? "auto" : (
          parentType === "Client"
            ? `calc(100vh - ${isOverviewHeaderCollapsed ? "215" : "342"}px)`
            : parentType === "Portfolio"
              ? `calc(100vh - ${isOverviewHeaderCollapsed ? "215" : "405"}px)`
              : parentType === "Program"
                ? `calc(100vh - ${isOverviewHeaderCollapsed ? "215" : "405"}px)`
                : parentType === "Project" || parentType === "BudgetCategory"
                  ? `calc(100vh - ${isOverviewHeaderCollapsed ? "215" : "415"}px)`
                  : parentType === "Scope"
                    ? `calc(100vh - ${isOverviewHeaderCollapsed ? "135" : "292"}px)`
                    : type === "MeetingRegistry"
                      ? "calc(100vh - 108px)"
                      : overviewType === "Dashboard"
                        ? type === "Portfolio"
                          ? "560px"
                          : "340px"
                        : null),
      }}
      ref={tableRef}
    >
      {/* Render Tables */}
      {renderTables(type)}

      {/* Confirmation */}
      {showConfirmationModal && (
        <Modal
          title={confirmationTitle}
          body={confirmationDesc}
          handleCancel={() => handeCancel()}
          handleSave={() => handleConfirm()}
          saveBtnLabel={saveBtnLabel}
          cancelBtnLabel={cancelBtnLabel}
          savebtnLabel={confirmationBtn}
          isLoading={false}
        />
      )}

      {/* Permissions */}
      {isPermissionModalOpen &&
        showPermissionModal &&
        !getPermissionLoading && (
          <Modal
            title={`${permissionTitle} - Permissions`}
            handleCancel={() => {
              setShowPermissionModal(false);
              dispatch(updatePermissionStatus());
            }}
            handleSave={handleSavePermissions}
            saveBtnLabel={saveBtnLabel}
            cancelBtnLabel={cancelBtnLabel}
            isLoading={modalLoading}
            size="large"
            footer={!isDefaultRole}
            body={
              <RolesSetup
                handlePermissions={handlePermissions}
                permissions={permissions}
                disabled={isDefaultRole}
              />
            }
          />
        )}

      {/* Reminder */}
      {showReminderModal && (
        <CreateReminder
          setIsModalOpen={setShowReminderModal}
          type={getReminderType(type)}
          selectedTag={selectedItem}
        />
      )}

      {/* Create/Edit Modals */}
      {showModal && (
        <Modal
          title={modalTitle}
          handleCancel={() => handeCancel()}
          handleSave={() => handleSave()}
          saveBtnLabel={saveBtnLabel}
          cancelBtnLabel={cancelBtnLabel}
          isSaveBtnDisabled={isModalSaveBtnDisabled}
          isLoading={modalLoading}
          body={body}
          size="large"
          width={getModalWidth()}
        />
      )}

      {/* Delete Modal */}
      {showDeleteModal && (
        <Modal
          title={`Delete ${type}`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the selected ${type.toLowerCase()}?`}</p>
          }
          handleCancel={() => handeCancel()}
          handleSave={() => handleDelete(selectedItem)}
          saveBtnLabel="Delete"
          cancelBtnLabel={cancelBtnLabel}
          isLoading={modalLoading}
        />
      )}
      {/* Table Action Modal */}
      {TableActionModalData && TableActionModalData?.isShow && (
        <Modal
          title={`${TableActionModalData?.title}`}
          body={
            <p className="text-sm-400 subHeading-color">{TableActionModalData?.body}</p>
          }
          handleCancel={TableActionModalData?.handleCancel}
          handleSave={TableActionModalData?.handleConfirm}
          saveBtnLabel={TableActionModalData?.saveBtnLabel}
          cancelBtnLabel={TableActionModalData?.cancelBtnLabel}
          isLoading={modalLoading}
        />
      )}
    </div>
  );
};

export default Table;
